import styled from 'styled-components'
import { ResponsivePicture } from '../ResponsivePicture/ResponsivePicture'

export const Background = styled.div`
  background-color: ${({ theme }) => theme.colors.background};
`

export const Frame = styled.section`
  @media screen and (min-width: 768px) {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: auto;
    min-height: 70rem;
  }
`

export const ImageWrapper = styled.div`
  @media screen and (min-width: 768px) {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 4.6rem;
  }
`

export const Image = styled(ResponsivePicture)`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

export const Description = styled.div`
  background: ${({ theme }) => theme.colors.background};
  position: relative;
  z-index: 1;
  padding: 4rem 3rem 6rem;
  margin: 0 auto;

  @media screen and (min-width: 768px) {
    max-width: 50rem;
    padding: 6.6rem 5rem 5rem;
  }
`
